"use client";

import Link from "@/components/ui/CcLink";
import type { ComponentProps } from "react";

import { useLocalizedHref } from "@/components/layout/CcLocaleContext";

type CcInternalLinkProps = Omit<ComponentProps<typeof Link>, "href"> & {
  href: string;
};

/** Next `Link` with locale prefix applied to internal marketing paths. */
export function CcInternalLink({ href, ...rest }: CcInternalLinkProps) {
  const localizedHref = useLocalizedHref(href);
  return <Link href={localizedHref} {...rest} />;
}
